<template>
  <div class="about" style="padding: 0 12px; background-color: #ffffff;min-height: 100%;">
    <div style="font-size: 18px;padding: 32px 0;">
      <div>在线办理 足不出户</div>
      <div>微信扫码即可完成验证</div>
    </div>

    <div>
      <div class="cus-row" style="margin: 0 -7px;">
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_08.png"/>

            <div class="item-title">营业执照公证</div>

            <div class="item-desc">（法人<span style="color: #f25422;">能参与</span>微信人脸验证）</div>

            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(91)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_08.png"/>

            <div class="item-title">营业执照公证</div>

            <div class="item-desc">（法人<span style="color: #f25422;">不能参与</span>微信人脸验证）</div>

            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(100)" target="_blank">查看详情</a>
            </div>
          </div>


        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_11.png"/>

            <div class="item-title">身份证公证</div>

            <div class="item-desc">（必须本人人脸验证）</div>

            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(102)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_03.png"/>

            <div class="item-title">户口公证</div>

            <div class="item-desc">（必须本人人脸验证）</div>

            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(103)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
      </div>

      <div class="cus-row" style="margin: 0 -7px;">
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_24.png"/>

            <div class="item-title">授权委托书模板</div>


            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(95)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_27.png"/>

            <div class="item-title">公证书和发票范本</div>


            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(96)" target="_blank">查看详情</a>
            </div>
          </div>


        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_18.png"/>

            <div class="item-title">常见问题</div>


            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(97)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
        <div class="cus-row-col-6 amazon-item">
          <div class="item">
            <img src="../assets/images/amazon/01_21.png"/>

            <div class="item-title">扫码验证</div>


            <div style="text-align: center">
              <a class="seeDetail do_btn" @click="goServe(98)" target="_blank">查看详情</a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div style="height: 80px;">

    </div>

  </div>
</template>

<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import stroe from '../store'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        addone
      },
  data: function(){
    return {
      roleCn:'',
      phone:'',
      isLogin: false,
      info: {}
    }
  },
  methods:{
    goServe(id)
    {
      this.$router.push({path: '/amazon_serve', query: {id: id}})
    },
    goLogin()
    {
      this.$router.push({path: '/auth'})
    },
    goAbout()
    {
      this.$router.push({path: '/about', query:{type: 'about'}})
    },
    goSafe()
    {
      this.$router.push({path: '/about', query:{type: 'safe_ensure'}})
    },
    goCommonQue()
    {
      this.$router.push({path: 'common_que'})
    },
    initPage:function()
    {
      this.isLogin = common.getAuth()?common.getAuth():''
      //如果登录了，显示登陆后的信息

      common.cusHttp(this,'/boot/auth.php',{action:'info', id:  this.isLogin}, 'get').then((res)=>{
        // console.log(res.data);
        res = JSON.parse(res.data)
        this.info = res.data
      })
    },
    loginOut:function()
    {
      // this.$store.commit('setAccessToken','')
      // this.$router.push('/auth')
      common.setAuth('')
      location.href = this.$router.push('/auth')
    },
    resetPassword:function()
    {
      this.$router.push('reset_password')
    }
  },
  created:function()
  {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this)

    common.setTitle('确认信息');
    this.id = common.queryValue('id');
  },
  mounted()
  {
    // alert('执行')
    // this.$emit('committarbar',2)
    stroe.commit('setTarbarIndex',4)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
  }
}
</script>

<style scoped>
.fs-14-fc-ffffff
{
  color: #ffffff;;
  font-size: 0.4375rem;
  font-family: PingFangSC-Medium;
  line-height: 0.525rem;
}


 .amazon-item{
   padding: 0 7px;
   box-sizing: border-box;
 }

.amazon-item .item{
  background: #ffffff;
  text-align: center;
  padding-top: 42px;
  border: 1px solid rgb(230, 230, 230);
  margin-top: 12px;
}

.amazon-item .item img{
  display: inline;
  object-fit: contain;
  width: 75px;
  height: 100px;
  display: inline-block;
}

.item-title
{
  font-size: 17px;
  text-align: center;
  color: #f25422;
  font-weight: 500;
  margin-top: 6px;
  line-height: 30px;
}


.item-desc{
  font-size: 12px;
  text-align: center;
  color: rgba(0,0,0,.4);
  line-height: 20px;
}

.seeDetail
{
  background-color: #f25422;
  line-height: 35px;
  color: #ffffff;
  font-size: 14px;
  padding: 0 24px;
  display: inline-block;
  border-radius: 35px;
  height: 35px;
  margin: 24px 0 24px 0;
}

.in-bl-lines
{
  padding: 24px 50px;
}

.in-bl-lines img
{
  width: 35%;
}

.amazon-num
{
  font-size: 18px;
  color: #f25422;
  font-weight: 500;
  line-height: 30px;
}

.amazon-desc
{
  font-size: 14px;
  color: rgba(0,0,0,.4);
  line-height: 20px;
}
</style>
